import { createUseStyles } from 'react-jss'

export const style = {
  chartContainer: {},
  controlBarContainer: {
    '& + $chartContainer': {
      marginTop: 30
    }
  },
  sideBySideChart: {
    width: 'calc(50% - 8px)'
  },
  sideBySideChartFilterBar: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
    '& .split-chart-filter-bar-element': {
      width: 500,
      display: 'flex',
      justifyContent: 'center'
    }
  }
}

export const useStyles = createUseStyles(style)
